import { Box, Button, Dialog, Heading, Icon, Text } from '@betterment/samba-react';
import { SambaAutoLink } from '@betterment/shared-components';

import { EstimatedTradeTiming } from '../../graphql/schema';
import { urlBuilder } from '../../Shared/urlBuilder';

type Params = {
  estimatedTradeTiming: EstimatedTradeTiming;
};

export const EstimatedTradeTimingDialog: React.FC<Params> = ({ estimatedTradeTiming }) => {
  if (estimatedTradeTiming.__typename === 'EstimatedTradeDate') {
    return <Text>{estimatedTradeTiming.description}</Text>;
  }

  return (
    <Dialog>
      <Dialog.Trigger asChild={true}>
        <Box
          css={{
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
          <Box css={{ alignSelf: 'center', display: 'flex', alignItems: 'flex-start' }}>
            <Text>Estimated trade time</Text>
          </Box>
          <Box css={{ alignSelf: 'center', display: 'flex', alignItems: 'flex-start' }}>
            <Box css={{ display: 'flex', flexDirection: 'column' }}>
              <Text css={{ alignSelf: 'end' }}>{estimatedTradeTiming.dayDescription}</Text>
              <Text
                css={{
                  alignSelf: 'end',
                  color: 'text.weak',
                }}
                variant="text50"
              >
                {estimatedTradeTiming.timeRangeDescription}
              </Text>
            </Box>
            <Box css={{ alignSelf: 'center' }}>
              <Icon name="CaretRight" size="small" color="icon" />
            </Box>
          </Box>
        </Box>
      </Dialog.Trigger>
      <Dialog.Content css={{ p: 'space.400', width: '50%' }}>
        <Dialog.Title>
          <Heading>Estimated trade time</Heading>
        </Dialog.Title>
        <Dialog.Description>
          Your order will be placed in the next trading window at the market price available when it executes.{' '}
          <SambaAutoLink to={urlBuilder.getSelfDirectedInvestingDisclosure()} target="_blank" rel="noopener noreferrer">
            See disclosure
          </SambaAutoLink>
        </Dialog.Description>
        <Dialog.Close asChild={true}>
          <Button variant="solidSecondary" css={{ mt: 'space.300' }}>
            Close
          </Button>
        </Dialog.Close>
      </Dialog.Content>
    </Dialog>
  );
};
